module.exports = __webpack_public_path__ + "img/swiper2.0fb48e4a.png";